const ROUTE_PATHS = {
  HOME: "/",
  WSM_SIGNIN: "/sign-in",
  WSM_INITIAL_LOAD: "/loading",
  WSM_PROFILE_SETUP: "/profile-setup",
  WSM_FAQ: "/faq",
  WSM_KEYS: "/keys",
  WSM_HOME: "/home",
  WSM_CALENDAR: "/calendar",
  WSM_WORKSPACE_DETAIL: "/calendar/workspace-detail/:slotId",
  WSM_RETREAT_DETAIL: "/calendar/retreat-detail/:slotId",
  WSM_MEETING_ROOM_LIST: "/calendar/meeting-rooms",
  WSM_CALENDAR_SUCCESS: "/calendar/success",
  WSM_CALENDAR_PAYMENT: "/calendar/payment",
  WSM_CALENDAR_DF_WORKSPACE_DETAIL: "/calendar/df-workspace",
  WSM_CALENDAR_INNOVATIVE_SPACE: "/calendar/innovative-space",
  WSM_CALENDAR_CREATIVE_SPACE: "/calendar/creative-space",
  WSM_CALENDAR_EVENT_DETAIL: "/calendar/event",
  WSM_CALENDAR_MB_STUDIO_DETAIL: "/calendar/mb-studio",
  WSM_CALENDAR_COMMUNICATE_SPACE_DETAIL: "/calendar/communicate-space",
  WSM_MEMBERSHIP_PLAN_DETAIL: "/membership/plan-membership",
  WSM_UR_MEMBERSHIP_PLAN_DETAIL: "/membership/ur-membership-plan",
  WSM_MEMBERSHIP_PAYMENT_DETAIL: "/membership/payment",
  WSM_MEMBERSHIP_CREDIT_PLAN_DETAIL: "/membership/credit-plan",
  WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL: "/membership/one-day-pass",
  WSM_PAYMENT_SUCCESS: "/payment-success/:invoiceId",
  WSM_RESERVATION_CANCEL: "/reservation/cancel",
  WSM_PAYMENT_HISTORY: "/payment-history",
  WSM_PAYMENT_HISTORY_DETAIL: "/payment-history/detail",
  WSM_ALL_SET: "/all-set",
  WSM_WEB_LINK_DETAIL: "/web-link",
};

export default ROUTE_PATHS;
